import { Divider } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';

export const MetricsDivider: FC = () => (
  <Divider
    style={{ margin: '8px 0', borderColor: BRAND_COLORS.secondary.steelBlue }}
  />
);
